import { releaseCanvas, releaseVideo } from '$utils/index';

export const ATTACHMENTS_COUNT_LIMIT = 50;


export function extractFramesFromVideo(videoUrl: string, amount: number) {
  return new Promise((resolve: (frames: string[]) => void, reject) => {
    const frames: string[] = [];
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const video = document.createElement('video');

    video.addEventListener('loadeddata', async function () {
      try {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const startFrame = 0.033;
        const duration = video.duration - startFrame;
        const interval = duration / amount;

        for (let time = startFrame; time <= duration; time += interval) {
          await new Promise<void>((seekResolve) => {
            const onSeeked = () => {
              video.removeEventListener('seeked', onSeeked);
              context?.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
              frames.push(canvas.toDataURL());
              seekResolve();
            };

            video.addEventListener('seeked', onSeeked);
            video.currentTime = time;
          });
        }

        releaseVideo(video);
        releaseCanvas(canvas);
        resolve(frames);
      } catch (e) {
        reject(e);
      }
    });

    video.addEventListener('error', (event) => {
      releaseVideo(video);
      releaseCanvas(canvas);
      reject(event);
    });

    video.autoplay = true; // bugfix for iPhone
    video.muted = true;
    // https://stackoverflow.com/questions/33300294/html5-video-loadeddata-event-does-not-work-in-ios-safari

    video.src = videoUrl;
    video.load();
  });
}

export function readFile(file): Promise<string> {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = function () {
      resolve(reader.result as string);
    };

    reader.onerror = function () {
      reject(reader.error);
    };
  });
}

export function getVideoDuration(url): Promise<number> {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.preload = 'auto';

    video.addEventListener('loadedmetadata', () => {
      resolve(video.duration);
    });

    video.addEventListener('error', (event) => {
      reject(event);
    });

    video.src = url;
    video.load();
  });
}

export function choseFiles(
  multiple = true,
  accept = 'image/*,video/*',
): Promise<FileList> {
  return new Promise((resolve, reject) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept;
    input.multiple = multiple;
    input.onchange = () => {
      if (input.files?.length) {
        resolve(input.files);
      } else {
        reject();
      }
    };
    input.click();
  });
}
